import { Button, Divider, Flex, Form, Modal } from 'antd'
import { useUnit } from 'effector-react'
import { DebtForm } from 'src/pages/finSystem/debt/atoms'
import {
  debtListLoad,
  submitCreateDebtFx,
} from 'src/pages/finSystem/debt/model'
import dayjs from 'dayjs'
import { DebtPayload, ListRequest } from 'src/pages/finSystem/debt/types'
import { ModalType } from 'src/pages/finSystem/wallets/atoms/types'
import { $params } from 'src/features/router'
import { $wallet as $currentWallet } from 'src/pages/finSystem/wallets/details/model'

type Props = {
  isOpen: boolean
  onClose: () => void
  filters?: Record<string, any>
  type?: ModalType
}

export const CreateDebtModal = ({ isOpen, onClose, filters, type }: Props) => {
  const [form] = Form.useForm()
  const loadingButton = useUnit(submitCreateDebtFx.pending)
  const currentWallet = useUnit($currentWallet)
  const params = useUnit($params)
  const initialWalletId =
    params?.walletID ||
    (type === 'wallet' && currentWallet.id ? currentWallet.id : '')
  const {
    id,
    walletIds,
    dateFrom,
    dateTo,
    userId,
    statuses,
    sorterField,
    page,
    pageSize,
  } = filters || {}

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      const body: DebtPayload = {
        wallet: values.wallet,
        currency: values.currency,
        exchangeRate: values.exchangeRate ? values.exchangeRate : null,
        debtAmount: values.debtAmount,
        recoveredAmount: values.recoveredAmount,
        status: values.status,
        dateTime: `${dayjs(values.date).format('YYYY-MM-DD')} ${dayjs(
          values.time,
        ).format('HH:mm:ss')}`,

        ...(values.userId && { userId: values.userId }),
        ...(values.comment && { comment: values.comment }),
      }
      await submitCreateDebtFx({ body })
      onClose()
      if (filters) {
        debtListLoad({
          id,
          walletIds,
          dateFrom,
          dateTo,
          userId,
          statuses,
          sorterField,
          page,
          pageSize,
        } as ListRequest)
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Create Debt Transaction</div>}
      centered
      wrapClassName="ant_modal"
      width={600}
      maskClosable={false}
      open={isOpen}
      onCancel={onClose}
      destroyOnHidden
      afterOpenChange={(open) => {
        if (!open) {
          form.resetFields()
        }
      }}
      footer={
        <Flex gap={8} justify="flex-end">
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            onClick={handleSubmit}
            loading={loadingButton}
          >
            Save
          </Button>
        </Flex>
      }
    >
      <Divider />
      <DebtForm
        form={form}
        walletDisabled={type === 'wallet' || !!params?.walletID}
        initialValues={{
          wallet: initialWalletId ? Number(initialWalletId) : undefined,
          recoveredAmount: 0,
          status: 'Active',
        }}
      />
    </Modal>
  )
}
